export default {
    team: {
        teamSpace: 'Team Space',
        teamSpaceDescription: 'Create team/enterprise space, invite team members and enterprise employees to join. Set different permission roles and authorize members. Help team collaboration while meeting the needs of enterprise fine management.',
        spaceAndMemberManagement: 'Space and Member Management',
        spaceAndMemberManagementDescription: 'One-click create exclusive space',
        spaceAndMemberManagementDescription2: 'Convenient enterprise member invitation',
        spaceAndMemberManagementDescription3: 'Team shared spaces and efficient collaboration',
        quotaManagement: 'Quota Management',
        quotaManagementDescription: 'Automatic periodic credit allocation for members',
        quotaManagementDescription2: 'Manual enterprise credit balance adjustment',
        quotaManagementDescription3: 'On-demand personal credit top-up support',
        rolePermissionSetting: 'Role Permission Setting',
        rolePermissionSettingDescription: 'Multiple enterprise role creation',
        rolePermissionSettingDescription2: 'Role-based functional and data permissions',
        rolePermissionSettingDescription3: 'Role-based member authorization system',
        memberManage: 'Members',
        roleManage: 'Role Management',
        enterpriseTotalScore: 'Enterprise Total Score ',
        searchMember: 'Search member name or phone number',
        selectRole: 'Please select role',
        allocatePoints: 'Allocate Points',
        setRole: 'Set Role',
        removeEnterprise: 'Remove Enterprise',
        removeTeam: 'Remove Team',
        inviteNewMember: 'Invite New Member',
        createTeam: 'Create Team',
        memberName: 'Member Name',
        roleName: 'Role',
        phoneNumber: 'Phone Number',
        enterpriseScore: 'Enterprise Score',
        joinTime: 'Join Time',
        operation: 'Operation',
        copy: 'Copy',
        join: 'Through this link to register or login, you can join the enterprise',
        joinTeam: 'Through this link to register or login, you can join the team',
        enterpriseName: 'Enterprise Name',
        teamName: 'Team Name',
        pleaseEnterName: 'Please enter name',
        description: 'Description',
        pleaseEnterScore: 'Please enter the credits to allocate ',
        score: 'Credits',
        allocatePointsDescription: 'After allocation, the enterprise credits of the member will be changed to the adjusted value, and the personal recharge credits of the member will not be affected',
        copySuccess: 'Copy Success',
        modifyImmediately: 'After modification, the member\'s permissions will be updated immediately, are you sure to modify?',
        editRole: 'Edit Role',
        setSuccess: 'Set Success',
        cancelSetting: 'Cancel Setting',
        confirmRemoveEnterprise: 'Are you sure to remove the member from the enterprise space?',
        confirmRemoveTeam: 'Are you sure to remove the member from the team space?',
        removeEnterpriseMember: 'Remove Enterprise Member',
        removeTeamMember: 'Remove Team Member',
        removeSuccess: 'Remove Success',
        cancelRemove: 'Cancel Remove',
        pleaseEnterCompanyName: 'Please enter company name',
        modifySuccess: 'Modify Success',
        createSuccess: 'Create Success',
        allocatePointsSuccess: 'Allocate Points Success',
        back: 'Back',
        roleNameTip: 'Role:',
        menuAndFunctionPermission: 'Menu and Function Permission',
        dataRangePermission: 'Data Range Permission',
        nextStep: 'Next Step',
        previousStep: 'Previous Step',
        submit: 'Submit',
        menuAndFunctionPermissionTip: 'The menu that the role can view in the system',
        dataRangePermissionTip: 'The data range that the role can view in the system',
        permissionSettingNotComplete: 'Permission setting is not complete, canceling will not be saved, are you sure to cancel?',
        tip: 'Tip',
        saveSuccess: 'Save Success',
        pleaseConfigureDataRangePermission: 'Please configure data range permission before saving',
        saveImmediately: 'Save immediately, the members who have been granted this role will also be updated synchronously, are you sure to modify?',
        cancelSubmit: 'Cancel Submit',
        createRole: 'Create Role',
        role: 'Role',
        type: 'Type',
        creator: 'Creator',
        createTime: 'Create Time',
        updateTime: 'Update Time',
        systemRole: 'System Role',
        customRole: 'Custom Role',
        deleteRole: 'Delete Role',
        roleDescriptionTip: 'Role Description ',
        pleaseEnterRoleName: 'Please enter role name',
        pleaseEnterRoleDescription: 'Please enter role description',
        deleteRoleTip: 'After deletion, the role cannot be recovered, are you sure to delete?',
        configure: 'Configure',
    }
}